/**
 * Icon component · SVG sprite reference · P1.8
 *
 * Per CLAUDE.md rule 3 · all icons must reference design-system/icons.svg
 * via `<use href="/icons.svg#ic-name" />`. NO emoji fallback.
 *
 * codex-review 2026-04-28 P1.8 P2 fix · the sprite icons are stroke-style
 * line icons · need fill:none + stroke:currentColor styling. Apply via
 * inline SVG attributes (works without external CSS · matches design-system
 * icons.css presentation rules).
 */

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  ariaLabel?: string;
}

export function Icon({ name, size = 16, className, ariaLabel }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      // Match design-system/icons.css presentation rules (stroke-style line icons)
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <use href={`/icons.svg#ic-${name}`} />
    </svg>
  );
}
